import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import IconBreadcrumbs from './IconBreadcrumbs';
import ClientProvider from './client';
export default createDemo(import.meta.url, IconBreadcrumbs, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/breadcrumbs/demos/icon/IconBreadcrumbs.tsx",
    "fileName": "IconBreadcrumbs.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Typography from '@mui/material/Typography';\nimport Breadcrumbs from '@mui/material/Breadcrumbs';\nimport Link from '@mui/material/Link';\nimport HomeIcon from '@mui/icons-material/Home';\nimport WhatshotIcon from '@mui/icons-material/Whatshot';\nimport GrainIcon from '@mui/icons-material/Grain';\n\nfunction handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {\n  event.preventDefault();\n  console.info('You clicked a breadcrumb.');\n}\n\nexport default function IconBreadcrumbs() {\n  return (\n    <div role=\"presentation\" onClick={handleClick}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Breadcrumbs aria-label=\"breadcrumb\">\n        <Link\n          underline=\"hover\"\n          sx={{ display: 'flex', alignItems: 'center' }}\n          color=\"inherit\"\n          href=\"/\"\n        >\n          <HomeIcon sx={{ mr: 0.5 }} fontSize=\"inherit\" />\n          MUI\n        </Link>\n        <Link\n          underline=\"hover\"\n          sx={{ display: 'flex', alignItems: 'center' }}\n          color=\"inherit\"\n          href=\"/material-ui/getting-started/installation/\"\n        >\n          <WhatshotIcon sx={{ mr: 0.5 }} fontSize=\"inherit\" />\n          Core\n        </Link>\n        <Typography\n          sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}\n        >\n          <GrainIcon sx={{ mr: 0.5 }} fontSize=\"inherit\" />\n          Breadcrumb\n        </Typography>\n      </Breadcrumbs>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 45,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Typography from '@mui/material/Typography';\nimport Breadcrumbs from '@mui/material/Breadcrumbs';\nimport Link from '@mui/material/Link';\nimport HomeIcon from '@mui/icons-material/Home';\nimport WhatshotIcon from '@mui/icons-material/Whatshot';\nimport GrainIcon from '@mui/icons-material/Grain';\n\nfunction handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {\n  event.preventDefault();\n  console.info('You clicked a breadcrumb.');\n}\n\nexport default function IconBreadcrumbs() {\n  return (\n    <div role=\"presentation\" onClick={handleClick}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Breadcrumbs aria-label=\"breadcrumb\">\n        <Link\n          underline=\"hover\"\n          sx={{ display: 'flex', alignItems: 'center' }}\n          color=\"inherit\"\n          href=\"/\"\n        >\n          <HomeIcon sx={{ mr: 0.5 }} fontSize=\"inherit\" />\n          MUI\n        </Link>\n        <Link\n          underline=\"hover\"\n          sx={{ display: 'flex', alignItems: 'center' }}\n          color=\"inherit\"\n          href=\"/material-ui/getting-started/installation/\"\n        >\n          <WhatshotIcon sx={{ mr: 0.5 }} fontSize=\"inherit\" />\n          Core\n        </Link>\n        <Typography\n          sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}\n        >\n          <GrainIcon sx={{ mr: 0.5 }} fontSize=\"inherit\" />\n          Breadcrumb\n        </Typography>\n      </Breadcrumbs>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 45,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Typography",
      "@mui/material/Breadcrumbs",
      "@mui/material/Link",
      "@mui/icons-material/Home",
      "@mui/icons-material/Whatshot",
      "@mui/icons-material/Grain"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
